import { render, staticRenderFns } from "./ActivityMove.vue?vue&type=template&id=92c8fefa&"
import script from "./ActivityMove.vue?vue&type=script&lang=js&"
export * from "./ActivityMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports